import { useCallback } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { AccountingPage } from '@/features/accounting/accounting-page'
import { ACCOUNTING_TABS, DEFAULT_ACCOUNTING_TAB, type AccountingTab } from '@/features/accounting/constants'
import { requirePermission } from '@/lib/route-guards'

/** `?tab=` recuerda la pestaña (diario, balanza, mayor, períodos). */
const accountingSearchSchema = z.object({
  tab: z.enum(ACCOUNTING_TABS).optional().catch(undefined),
})

/** Contabilidad: conciliación, libro diario, balanza, mayor y cierre de períodos. */
export const Route = createFileRoute('/_app/accounting/')({
  beforeLoad: requirePermission('accounting:read'),
  validateSearch: accountingSearchSchema,
  component: AccountingRoute,
})

function AccountingRoute() {
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()
  const onTabChange = useCallback((next: AccountingTab) => void navigate({ search: { tab: next }, replace: true }), [navigate])
  return <AccountingPage tab={tab ?? DEFAULT_ACCOUNTING_TAB} onTabChange={onTabChange} />
}
